import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78478592"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "indicator_wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "indicator_rec" })
], -1))
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal_title space-between" }, [
  /*#__PURE__*/_createElementVNode("span", null, "보유주식 팔기")
], -1))
const _hoisted_4 = { class: "modal_content" }
const _hoisted_5 = { class: "content_top" }
const _hoisted_6 = {
  key: 0,
  class: "result"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 팔기 조건 입력 완료 ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description" }, " 증명서류 확인 후 매물 목록에 노출됩니다. ", -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "result"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 내가 등록한 매물 ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description" }, [
  /*#__PURE__*/_createTextVNode(" 클럽딜 진행을 원하는 리드엔젤이 있을 경우"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 현황 알림을 전송해드릴게요 ")
], -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { class: "stock-item-name" }
const _hoisted_15 = { class: "small_logo" }
const _hoisted_16 = ["src"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_18 = { class: "item-name" }
const _hoisted_19 = { class: "sell-info" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ion-float-left" }, " 희망 가격 ", -1))
const _hoisted_21 = { class: "bold" }
const _hoisted_22 = { class: "" }
const _hoisted_23 = { class: "sell-info" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ion-float-left" }, " 희망 수량 ", -1))
const _hoisted_25 = { class: "bold" }
const _hoisted_26 = { class: "light" }
const _hoisted_27 = { class: "sell-info" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ion-float-left" }, " 판매 가능 최소량 ", -1))
const _hoisted_29 = { class: "bold" }
const _hoisted_30 = { class: "light" }
const _hoisted_31 = { class: "sell-info" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ion-float-left" }, " 증명서류 ", -1))
const _hoisted_33 = { class: "ion-float-right fill" }
const _hoisted_34 = {
  key: 0,
  class: ""
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sell-info" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ion-float-left" }, " 판매수수료 "),
  /*#__PURE__*/_createElementVNode("div", { class: "ion-float-right fill" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "angel-text-red font-bold" }, "무료")
  ])
], -1))
const _hoisted_36 = {
  slot: "fixed",
  class: "bottom"
}
const _hoisted_37 = { class: "content_bottom" }
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" 팔기 취소 ")
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" 확인 ")
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" 조건 수정 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createBlock(_component_ion_content, { class: "wrapper" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.updateComplete)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9))
              : (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_13)),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("img", {
                  onerror: "this.src='https://static.angelleague.io/images/bk_v.png'",
                  src: _ctx.sellInfo.companyLogo?_ctx.sellInfo.companyLogo:'https://static.angelleague.io/images/bk_v.png',
                  class: "img-responsive img-circle"
                }, null, 8, _hoisted_16),
                _hoisted_17
              ]),
              _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.sellInfo.stockItemName), 1)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("div", {
                class: _normalizeClass(["ion-float-right", {fill:(!!_ctx.sellInfo.sellPrice)}])
              }, [
                _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$filters.currency(_ctx.sellInfo.sellPrice)||'-') + " 원", 1),
                _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.sellInfo.sellPriceNegoFlag===true?' · 협의가능':''), 1)
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("div", {
                class: _normalizeClass(["ion-float-right", {fill:(!!_ctx.sellInfo.qty)}])
              }, [
                _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$filters.currency(_ctx.sellInfo.qty)||'-') + " 주", 1),
                _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.sellInfo.qty?` (총 ${_ctx.$filters.currency(_ctx.sellInfo.sellPrice*_ctx.sellInfo.qty)}원)`:''), 1)
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("div", {
                class: _normalizeClass(["ion-float-right", {fill:(!!_ctx.sellInfo.sellMinQty)}])
              }, [
                _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$filters.currency(_ctx.sellInfo.sellMinQty)||'-') + " 주", 1),
                _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.sellInfo.sellMinQty?` (총 ${_ctx.$filters.currency(_ctx.sellInfo.sellPrice*_ctx.sellInfo.sellMinQty)}원)`:''), 1)
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _createElementVNode("div", _hoisted_33, [
                (_ctx.sellInfo.files)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(_ctx.sellInfo.files?` ${_ctx.printFileNameMaxlength(_ctx.sellInfo.files.name,25)}`:''), 1))
                  : (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'증명서류', 'clickContent':'파일명'});_ctx.openMyFile(_ctx.sellInfo.filePath)})
                    }, _toDisplayString(_ctx.printFileNameMaxlength(_ctx.sellInfo.originFileName,25)), 1))
              ])
            ]),
            _hoisted_35
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("button", {
                class: "ion-activatable ripple-parent previous_btn",
                onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼', 'clickContent':'팔기 취소'});_ctx.openAlert('cancel')})
              }, [
                _hoisted_38,
                _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
              ]),
              (_ctx.updateComplete)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "ion-activatable ripple-parent next_btn",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼', 'clickContent':'확인'});_ctx.checkConfirm()})
                  }, [
                    _hoisted_39,
                    _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                  ]))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "ion-activatable ripple-parent next_btn",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼', 'clickContent':'조건 수정'});_ctx.openSellModal()})
                  }, [
                    _hoisted_40,
                    _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                  ]))
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}